const state = {
	showGoods : false,
	selIds : '',
}

const mutations = {
	changeAnalyzeActive (state,payload){
		state.showGoods = payload;
	},
	changeAnalyzeId (state,payload){
		state.selIds = payload;
	},
}

export default {
	state,
	mutations
}



// WEBPACK FOOTER //
// ./src/storage/vuex/module/analyzeDialog.js